export const environment = {
  production: false,
  enableServiceWorker: true,
  // @ts-ignore
  apiUrl: window["ENV"]["API_URL"],
  appVersion: 'v1.2.13',
  // @ts-ignore
  paystackPublicKey: window["ENV"]["PAYSTACK_KEY"]
  };
